import { defineStore } from 'pinia'
import { baiduKey, getCityList, stringValue } from '~/server/common'

export const useCityInfoStore = defineStore({
  id: 'myUseCityInfoStore',
  state: () => ({
    cityList: [] as any[],
    cityInfo: {} as any,
    baiduKeyGa: '',
    baiduKey: '',
  }),
  getters: {
    city(state) {
      return state.cityInfo.city || 334
    },
    shortDomain(state) {
      return state.cityInfo.shortDomain || 'jx'
    },
    cityP() {
      return `ci${this.city}`
    },
    cityName(state) {
      return state.cityInfo.cityName || '嘉兴'
    },
  },
  actions: {
    /**
     * 获取城市信息
     */
    async setCityInfo(domain: string) {
      /**
       * 只在cityList没有数据的时候调用
       */
      if (this.cityList?.length === 0 || !this.cityList) {
        const { data: cityListData } = await useAsyncData(() => getCityList(), {
          transform: (res) => {
            return res || []
          },
        })
        if (Array.isArray(cityListData.value)) {
          this.cityList = cityListData.value
          const cityInfo: any = cityListData.value.find((item: any) => item.url === domain)
          this.cityInfo = cityInfo || {}
        }
      }
      else {
        const cityInfo: any = this.cityList.find((item: any) => item.url === domain)
        this.cityInfo = cityInfo || {}
      }

      // 获取百度key
      const { city = 0 } = this.cityInfo
      // 固安站点特殊处理，增加独立统计代码
      if (city && Number.parseInt(city) === 1325) {
        const { value: gaBaiduKey } = await stringValue({
          cityId: city,
          code: 'baiduAdTongjiM',
          pparameterId: 21,
        })
        this.baiduKeyGa = gaBaiduKey
      }
      const resKey = await baiduKey({
        cityId: city,
        code: 'baiduAdTongjiM',
        pparameterId: 21,
      })
      const value = resKey
      this.baiduKey = value
    },
    /**
     * 获取传入cityId的城市信息
     */
    getCityInfoByCityId(cityId: number) {
      const cityData: any = this.cityList.find((item: any) => item.city === cityId)
      return cityData
    },
  },
  persist: {
    storage: persistedState.localStorage,
  },
})
